import Dialog from '@mui/material/Dialog'
import { ModalWrapper, ModalTitle, ModalText, ConfirmButton } from './style'

interface Props {
    open: boolean
    title: string
    text: string
    onClose: () => void
    onConfirm: () => void
}

const ConfirmModal = ({ onConfirm, open, onClose, title, text }: Props) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <ModalWrapper>
                <ModalTitle>{title}</ModalTitle>
                <ModalText>{text}</ModalText>

                <ConfirmButton onClick={onConfirm}>CONFIRM</ConfirmButton>
            </ModalWrapper>
        </Dialog>
    )
}

export default ConfirmModal
